import { FC, useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { NavigationMenuProps, ActiveMenuItem, MainMenuItem } from './NavigationMenu.types';
import { NavigationMenuDesktop } from './NavigationMenuDesktop';
import { baseVariables } from '@marriott/mi-ui-library';
import { NavigationMenuMobile } from './NavigationMenuMobile';
import { useLocaleStore, useMediaQueryStore } from '../../store';
import { useMediaQuery } from '../../hooks';

export const NavigationMenuConfig = {
  emptyLabel: 'NavigationMenu',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/shoppingpages/sectionNavigation`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NavigationMenu: FC<{ model: NavigationMenuProps }> = (props: any) => {
  const { model } = props;
  const { sectionNavigationItems } = model;

  const { rtl } = useLocaleStore();
  const { isDesktop, setIsDesktop } = useMediaQueryStore();

  const matchesDesktop = useMediaQuery(baseVariables.mediaQuery.lg);

  const [activeMenuItem, setActiveMenuItem] = useState<ActiveMenuItem>({
    menuLabel: '',
    subMenuLabel: '',
    title: '',
  });

  useEffect(() => {
    if (matchesDesktop !== null) {
      setIsDesktop(matchesDesktop);
    }
  }, [matchesDesktop, setIsDesktop]);

  useEffect(() => {
    if (sectionNavigationItems.length) {
      const activePath = window.location.pathname;
      /*
        Determines if a navigation tab should be marked as active based on the current URL.
        Supports highlighting parent tabs when the user is on a nested or child route.
      */
      (sectionNavigationItems as MainMenuItem[]).some(mainMenuItem => {
        const { menuItemLabel, menuItemPath, sectionNavigationSubItems, defaultActivePathField } = mainMenuItem;

        if (
          !sectionNavigationSubItems.length &&
          (menuItemPath === activePath ||
            defaultActivePathField?.some(defaultPath => activePath?.includes(defaultPath)))
        ) {
          setActiveMenuItem({
            menuLabel: menuItemLabel,
            subMenuLabel: '',
            title: menuItemLabel,
          });
          return true;
        }

        const subMenuItem = sectionNavigationSubItems?.find(subMenuItem => subMenuItem.subMenuItemPath === activePath);
        if (subMenuItem) {
          setActiveMenuItem({
            menuLabel: menuItemLabel,
            subMenuLabel: subMenuItem.subMenuItemLabel,
            title: menuItemPath === activePath ? menuItemLabel : subMenuItem.subMenuItemLabel,
          });
          return true;
        }

        return false;
      });
    }
  }, [sectionNavigationItems]);

  return (
    <EditableComponent config={NavigationMenuConfig} {...props}>
      <div
        className="nav-menu m-container-fullbleed"
        data-testid="sectionnavigation"
        data-component-name="o-groups-sectionnavigation"
      >
        {isDesktop ? (
          <NavigationMenuDesktop {...model} activeMenuItem={activeMenuItem} />
        ) : (
          <NavigationMenuMobile {...model} activeMenuItem={activeMenuItem} dir={rtl ? 'rtl' : 'ltr'} />
        )}
      </div>
    </EditableComponent>
  );
};
